import type { User } from 'oidc-client-ts';

interface ISignInState {
    returnTo: string;
}

export function serializeSignInState(state: ISignInState) {
    return JSON.stringify(state);
}

export function deserializeSignInState(user: User) {
    return JSON.parse(user.state as string) as ISignInState;
}
